import React, { Component } from "react";
import {Text} from "@chakra-ui/react";




export default class ReadOnlyInput extends Component 
{

    render() 
    {
        return(                
            <Text fontSize={{ base: '14px', md: '20px', lg: '24px' }} color="white" margin='0'>{this.props.valueBag[this.props.card.id]}</Text>
        )
    }
}
